import useApi, { ApiOptions } from '../base/useApi';
import MigrationItemViewDTO from '@src/adapters/dto/migration/MigrationItemViewDTO';
interface Params {
  migrationId: string;
  inventoryId: string;
}

interface Result {
  item: MigrationItemViewDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/create_item_with_inventory',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useCreateMigrationItemWithInventoryLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useCreateMigrationItemWithInventoryLazy;
